import React from 'react';
import { Table } from 'antd';

import { TableCol } from './getTableCol';

import { courseStruct } from './struct';

const { table } = courseStruct;

export const Course = ({ courses }) => {

  const columns = [
    ...TableCol(),
  ];


  return courses?.length > 0 ? (
    <>
      <Table {...table} columns={columns} dataSource={courses} />
    </>
  ) : (
    <></>
  );
};
